import { TableColumn } from "react-data-table-component";
import { Link } from "react-router-dom";
import { LI, UL } from "../../AbstractElements";
import { ProductRowType } from "../../Types/ProductManagement";
import {
  CompanyRoleTableActionTypes,
  FormAccess,
} from "../../Types/UserManagement";
import { ProductRequestManagementRoute } from "../../utils/Constant";
import { format } from 'date-fns';

export const ProductColumnStructure: TableColumn<ProductRowType>[] = [
  {
    name: "Request ID",
    selector: (row) => row.id,
    sortable: true,
    center: false,
  },
  {
    name: "Product Name",
    selector: (row) => row.productType?.name,
    sortable: true,
    center: true,
  },
  {
    name: "Pricing",
    selector: (row) => `$ ${row.productType?.price}`,
    sortable: true,
    center: true,
  },
  {
    name: "Period",
    selector: (row) => `${format(new Date(row.rentalStartDate), 'yyyy/MM/dd')} - ${format(new Date(row.rentalEndDate), 'yyyy/MM/dd')}`,
    sortable: true,
    center: true,
  },
  {
    name: "Status",
    selector: (row) => row.status,
    sortable: true,
    center: true,
    cell: (row) => {
      if (row.status === "pending") {
        return <p>New</p>;
      }
      return <p>{row.status}</p>;
    },
  },
  {
    name: "Action",
    cell: (row) => (
      <TableActions
        id={row.id}
        setCentered={row.setCentered}
        modalDetails={row.modalDetails}
      />
    ),
    sortable: true,
    center: true,
  },
];

const TableActions: React.FC<CompanyRoleTableActionTypes> = ({
  id,
  setCentered,
  modalDetails,
}) => {
  const handleDeleteClick = () => {
    setCentered && setCentered(true);
    modalDetails &&
      modalDetails({
        id,
        type: FormAccess.DELETE,
      });
  };

  return (
    <UL className="action simple-list flex-row gap-2" id={id}>
      <LI className="create" aria-disabled onClick={handleDeleteClick}>
        <Link to={`/${ProductRequestManagementRoute}/${id}`}>
        <i className="icon-eye" />
        </Link>
      </LI>
    </UL>
  );
};
